
import { Vue, Component, Watch } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import { formatUpyunUrl } from "@/utils";
// import {openJesongChat} from "easy"
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { generateMetaInfo, getServiceJsonLd, getFaqJsonLd, injectJsonLd } from "@/utils/seo";
@Component({
  components: {
    ApplyForm,
    PictureSlide,
    Breadcrumb
  }
})
export default class flywheel extends Vue {
  get metaInfo() {
    return generateMetaInfo({
      title: "绩效飞轮® | 让战略成为每个人的日常工作 - 光华赋能",
      description:
        "光华绩效飞轮®是一套让战略落地的绩效管理方法论与工具，通过战略解码、目标对齐、过程管理、绩效复盘的闭环，让战略成为每个人的日常工作，驱动企业持续增长。",
      keywords:
        "绩效飞轮,绩效管理,战略落地,战略解码,目标管理,OKR,KPI,绩效复盘,光华赋能",
      path: "/performance-flywheel",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "数字化" },
        { name: "绩效飞轮" }
      ],
      jsonLd: getServiceJsonLd({
        name: "绩效飞轮",
        description:
          "一套让战略落地的绩效管理方法论与工具，通过战略解码、目标对齐、过程管理、绩效复盘的闭环驱动企业增长。",
        category: "绩效管理方法论"
      })
    });
  }

  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/ff7f2204f5ab03254b1fb553ced0d190.png";
  pic2 = "/img/5a90876859ffc33cf178d9854ac47928.png";
  pic3 = "/img/5fa2c1424e5517fa3ab5b354aef2314f.png";
  pic4 = "/img/59122153d5f0d2b247a1732208d4ac22.png";
  pic5 = "/img/e53d8cc1b3a33315db01b32b0a2f673f.png";
  pic6 = "/img/eb318bf19b32ebb9a916a740e9f872ff.png";
  pic7 = "/img/499ce5b75ba94ae2a08251d03f615d8a.png";
  List = [
    { title: "数字化", url: "" },
    { title: "绩效飞轮", url: "" }
  ];
  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "数字化方案陪跑，EPM企业绩效系统，绩效飞轮，ELP，微学，光华商学"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "专家，落地指导，规划，战略到执行，数字化转型方案，数字化，转型，数字化+，+数字化，数字化管理体系，业务转型，效率提升，持续增长，底层框架 ,全盘规划,从战略到执行全流程,过程,落地,问题,目标,调研,诊断,成果,复盘,赛道分析,企业位置,行业趋势,企业现状营收、盈利、规模、定位、生态位、战略控制点、价值主张,组织与人才,人才、组织盘点,结构、员工数,管理体系机制、制度、流程（尤其是业务主流程）、股权,差距分析,机会差距,业绩差距,三找,找差距、找不满、,找原因,梳理核心问题,对标对标杆,对历史数据,对BLM,目标共识,FCIL四个角度,企业培训,海量课程库，阶段目录，有序学习，要点检测，成果考核，加深理解，记忆实践，巧用关联，灵活使用，学，考，练，用，个人学习，缺乏体系，员工提升，管理层、电商、营销等不同团队缺乏专属课程资源，无法进行精准的专项培训，人才培养效率低下，因学习资源与培训体系不完善，导致关键岗位的能力成长缓慢，业务发展受到制约，人才培养的滞后，最终成为企业创新与增长步伐的瓶颈，实力名师，体系化学习，结构化知识体系，精品课，试听"
    );
    document.head.appendChild(metaTag2);
    // 注入 FAQPage JSON-LD
    injectJsonLd(
      "jsonld-faq",
      getFaqJsonLd([
        {
          question: "绩效飞轮是什么？",
          answer: "绩效飞轮是光华数字化推出的企业数字化绩效全过程云管理平台，以BLM科学经营为底座，帮助企业让战略成为每个人的日常工作，实现从战略制定到执行落地的全流程数字化管理。"
        },
        {
          question: "绩效飞轮适合什么企业？",
          answer: "绩效飞轮适合有一定规模、需要系统化绩效管理的成长型企业，特别是希望通过数字化工具提升组织效率、实现战略落地的企业。"
        },
        {
          question: "绩效飞轮有哪些核心功能？",
          answer: "绩效飞轮涵盖目标管理、过程跟踪、绩效评估、反馈改进等核心模块，支持企业从战略解码到个人绩效的全流程管理，帮助企业建立持续运转的绩效飞轮机制。"
        },
        {
          question: "绩效飞轮和传统OA有什么区别？",
          answer: "传统OA侧重流程审批，绩效飞轮以BLM科学经营方法论为底座，聚焦战略到执行的全链路绩效管理，不仅是工具，更是方法论+工具+陪跑的一体化解决方案。"
        }
      ])
    );
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
